import React from 'react'
import { useField } from 'formik'
import { Label } from '@/components/ui/label'
import IsoDatePicker from './IsoDatePicker'

const FormikIsoDate: React.FC<{ name: string; label: string; clearable?: boolean; disabled?: boolean }> = ({ name, label, clearable, disabled }) => {
  const [field, meta, helpers] = useField<string | null>(name)
  return (
    <div className="space-y-2">
      <Label htmlFor={name}>{label}</Label>
      <IsoDatePicker value={field.value ?? null} onChange={(v) => { helpers.setValue(v); helpers.setTouched(true) }} clearable={clearable} disabled={disabled} invalid={!!(meta.touched && meta.error)} />
      {meta.touched && meta.error && <p className="text-xs text-destructive">{meta.error}</p>}
    </div>
  )
}
export default FormikIsoDate
